// Фичефлаги: раздел «Гардероб» (и примерка полного лука) временно закрыт — раздел в обработке.
// Чтобы открыть: поставить true. Весь код гардероба/лука сохранён и протестирован.
export const WARDROBE_ENABLED = false;
